<template>
  <div class="config-table">
    <a-table
      :dataSource="state.dataSource"
      :columns="columns"
      :pagination="false"
      :scroll="{ x: scrollX }"
      row-key="id"
      bordered
      size="middle"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.dataIndex === 'index'">
          {{ index + 1 }}
        </template>
        <template v-else-if="column.dataIndex === 'categoryPath'">
          <span>{{ record.categoryPath }}</span>
        </template>
        <template v-else-if="column.dataIndex === 'status'">
          <a-popconfirm
            :title="
              record.supportStatus === 1
                ? '确定禁用该配置吗？'
                : '确定启用该配置吗？'
            "
            ok-text="确定"
            cancel-text="取消"
            @confirm="state.toggleStatus(record)"
          >
            <a-switch
              :checked="record.supportStatus === 1"
              checked-children="ON"
              un-checked-children="OFF"
            />
          </a-popconfirm>
        </template>
        <template v-else-if="column.dataIndex === 'action'">
          <a class="mr10" @click="state.handleCopyToCW(record)">快速复制</a>
          <a class="mr10" @click="state.handleEdit(record)">编辑</a>
          <a style="color: #ff4d4f" @click="state.openDeleteModal(record)">
            删除
          </a>
        </template>
        <template v-else-if="column.isCW">
          <span
            :class="{
              'cw-value': true,
              'cw-current': column.dataIndex === state.currentCW
            }"
          >
            {{
              record.weeklyData[column.dataIndex]
                ? record.weeklyData[column.dataIndex].toLocaleString()
                : '—'
            }}
          </span>
        </template>
      </template>
    </a-table>
    <div v-if="state.pageInfo.total > 0" class="config-table__pagination">
      <a-pagination
        :current="state.pageInfo.pageNum"
        :total="state.pageInfo.total"
        :page-size="state.pageInfo.pageSize"
        show-size-changer
        show-quick-jumper
        :show-total="total => `共 ${total} 条`"
        @change="state.onPageChange"
      />
    </div>
  </div>
</template>

<script>
import { inject, computed } from 'vue'

export default {
  name: 'ConfigTable',
  setup() {
    const state = inject('initState')

    const columns = computed(() => {
      const fixed = [
        {
          title: '序号',
          dataIndex: 'index',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '品类路径',
          dataIndex: 'categoryPath',
          width: 200,
          fixed: 'left'
        },
        {
          title: '扶持状态',
          dataIndex: 'status',
          width: 100,
          align: 'center',
          fixed: 'left'
        }
      ]

      const cwCols = (state.cwColumns || []).map(weekCode => {
        const weekItem = (state.weeksList || []).find(
          w => w.weekCode === weekCode
        )
        return {
          title: weekItem ? weekItem.cwDisplay : weekCode,
          dataIndex: weekCode,
          width: 120,
          align: 'right',
          isCW: true
        }
      })

      const action = [
        {
          title: '操作项',
          dataIndex: 'action',
          width: 180,
          align: 'center',
          fixed: 'right'
        }
      ]

      return [...fixed, ...cwCols, ...action]
    })

    const scrollX = computed(() => {
      const cwCount = (state.cwColumns || []).length
      return 60 + 200 + 100 + cwCount * 120 + 180
    })

    return { state, columns, scrollX }
  }
}
</script>

<style lang="scss" scoped>
.config-table {
  margin-top: 16px;

  &__pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
}

.category-link {
  color: #1890ff;
}

.cw-value {
  font-variant-numeric: tabular-nums;
}

.cw-current {
  color: #1890ff;
  font-weight: 500;
}
</style>
